import { processCSV as processCSVDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type processCSVProps = {}

export const processCSV = ({}: processCSVProps) => processCSVDiagram();
